module.exports = __webpack_public_path__ + "static/media/f-pop-up-3.c41a7350.png";